import React from 'react';
import classNames from 'classnames';

export interface IWFNXListCardProps {
  children?: React.ReactNode;
  className?: string;
}

export class WFNXListCard extends React.Component<IWFNXListCardProps, any> {
  render() {
    const { className, children } = this.props;
    const classes = [
      'wfnx-list-card'
    ];

    return (
      <div className={classNames(className, classes)}>
        {children}
      </div>
    );
  }
}
